export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'

export const LANGUAGES = {
  // "hr" : "Croatian",
  "en" : "English",
  "de" : "Deutsch",
  "fr" : "Français",
  "es" : "Español",
  "it" : "Italiano",
  "pl" : "Polski",
  "nl" : "Nederlands",
  "ro" : "Română",
  "cs" : "Čeština",
  "pt" : "Português",
  "ca" : "Català",
  "el" : "ελληνικά",
  "bg" : "Български",
  "sl" : "Slovenščina",
  "sv" : "Svenska",
  "da" : "Dansk",
  "et" : "Eesti",
  // "cs" : "Czech",
  // "fi" : "Finnish",
  // "hu" : "Hungarian",
}

export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGES).sort()
